import axios from 'axios';

let Rdv : any = {};
Rdv.submitForm = async (data:any) =>{
    
    return await axios.post(`${process.env.REACT_APP_BASE_URL}/api/rdv/send`, data)
}

export default Rdv;